import { Card, CardBody, Col } from "reactstrap";
import { LivePricesHeading } from "../../../../utils/Constant";
import CardHeaderCommon from "../../../../CommonElements/CommonCardHeader/CardHeaderCommon";
import LivePricesTable from "./LivePricesTable";

const LivePrices = () => {
  return (
    <Col xxl="3" xl="5" md="6" className="box-col-5 proorder-xl-5 proorder-lg-6">
      <Card className="live-price">
        <CardHeaderCommon  title={LivePricesHeading} />
        <CardBody className="pt-0">
          <LivePricesTable />
          
        </CardBody>
      </Card>
    </Col>
  );
};

export default LivePrices;
